import Link from 'next/link'
import styles from './dashboard.module.css'


function HeroCenter({ title, subtitle, shortText, btnText, url, bg, target, showBtn }) {
    
    return (
        <div className={`${styles.hero} ${bg} px-md-5 px-3 text-white`}>
            <div className={styles.content}>
                <h1 className={`${styles.title}  mb-3`}><strong>{title}</strong></h1>
                <p className={`${styles.desc} mb-5 `}>{subtitle}</p>
                {showBtn ? <p className={styles.desc}>{shortText}</p> : ''}
                {
                    (showBtn) 
                        ? <Link href={url} passHref><a className={`${styles.btnlearn} btnhero text-white rounded-pill d-inline-block text-uppercase`} target={target}><strong>{btnText}</strong></a></Link>
                        : ''
                }
                
            </div>
        </div>
    )
  }

export default HeroCenter;
